module.exports = __webpack_public_path__ + "img/4333471951c9d4bc53b837367efa11d5.png";